module.exports = __webpack_public_path__ + "img/4bc_Identity-Management.a12eb237.png";